import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import EzLink from "../EzLink/EzLink.es.js";
import { isLink } from "../EzLink/utils.es.js";
import EzButton from "../EzButton/EzButton.es.js";
const LinkButton = forwardRef(function LinkButton2({ label, accessibilityLabel, ...propsIn }, ref) {
  const buttonProps = { use: "tertiary", type: "button" };
  const commonProps = { ref, "aria-label": accessibilityLabel, children: label };
  return isLink(propsIn) ? /* @__PURE__ */ jsx(EzLink, { ...commonProps, ...propsIn }) : (
    // TODO: refactor to new EzButton after EzLink refactored -- styles need to match
    /* @__PURE__ */ jsx(EzButton, { legacy: true, ...buttonProps, ...commonProps, ...propsIn })
  );
});
export {
  LinkButton as default
};
//# sourceMappingURL=LinkButton.es.js.map
